import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, min } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CostoSegmentoTipoCamion;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un SucursalMunicipio
*/
export class CostoSegmentoTipoCamionEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            IdTipoCamion: validation.required,
            CostoFleteLogistica: validation.required
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const TipoCamion = getField(selectores.CpSatConfigAutotransporteSelector);
        const Number = getField(kea.Number);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Municipio"
            >

                <TipoCamion field="IdTipoCamion" label="Tipo Camion" />,
                <Number field="CostoFleteLogistica" label={"Costo"} format={"currency"} />
            </kea.Modal>
        )
    }
}   


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/segmentos/edit/modal.tsx